// extracted by mini-css-extract-plugin
export default {"DFSwitch":"R8Pp9tUlKDwYjyUDevGG","focused":"xh7KGbaw7AgqAlzsf0m_"};